import type { Lookups } from "../../types";
import type { FilterModule } from "../index";
import { ProductsFilter } from "./ProductsFilter";
import { getChips, getCount } from "./chips";
import { fromCompanyFilters, toCompanyFilters } from "./mapper";
import { defaultProductsSlice, type ProductsSlice } from "./slice";

export type { ProductsSlice } from "./slice";
export { defaultProductsSlice } from "./slice";

export const productsModule: FilterModule<ProductsSlice, Lookups> = {
  key: "products",
  defaultSlice: defaultProductsSlice,
  Component: ProductsFilter,
  getChips,
  getCount,
  toCompanyFilters,
  fromCompanyFilters,
};
